import {Component, ViewChild} from '@angular/core';
import {Router} from "@angular/router";

// components
import {TaskFormComponent} from "../task-form/task-form.component";

// services
import {AuthService} from "../../../shared/services/auth.service";
import {TasksService} from "../../../shared/services/tasks.service";
import {SnackbarService} from "../../../shared/services/snackbar.service";

// models
import {ApiMessage} from "../../../shared/models/api-message";


@Component({
    selector: 'app-task-save',
    templateUrl: './task-save.component.html',
    styleUrl: './task-save.component.scss'
})
export class TaskSaveComponent {

    @ViewChild('data') data!: TaskFormComponent;

    public isSaved = false;

    constructor(private authService: AuthService,
                private tasksService: TasksService,
                private snackbarService: SnackbarService,
                private router: Router) {
    }

    public addTask(): void {
        this.isSaved = true;
        const userType = this.authService.user.type;
        this.tasksService.createTask(userType, this.data.taskForm.getRawValue()).subscribe({
            next: (res: ApiMessage): void => {
                this.snackbarService.snackbarCustomComplete(res.message);
            },
            error: (e) => this.snackbarService.snackbarCustomError(e.error.message),
            complete: () => {
                this.closeForm();
                this.isSaved = false;
            }
        })
    }

    public closeForm(): void {
        this.router.navigateByUrl('/secure/tasks').then();
    }
}
